<template>
	<!-- 헤더 start -->
	<div class="bot_header">
		<div class="top_baro"><span class="bg_clip">사학연금</span></div>
		<h1 @click="onClickHome">사학연금</h1>
		<div class="head_right">
			<ul class="head_cont">
				<li v-if="user.userId" class="bot_user">
					<i class="fas fa-user"></i>{{ user.userId }}
					<!--<li v-if="loginUse" class="bot_user">
			<i class="fas fa-user"></i>{{ user.userNm }}  cspring-->
				</li>
				<li class="bot_menu">
					<a href="#" @click="onClickHelp" class="far fa-question-circle btn_bot_modal" :class="{ on: menuShow }"><span class="bg_clip">메뉴</span></a>
					<!--<a href="#" @click="onClickHelp" class="btn_menu fas fa-bars" :class="{ on: menuShow }"><span class="bg_clip">메뉴</span></a>-->
				</li>
			</ul>
			<!-- 메뉴 start -->
<!--			<transition name="fade">

				<ul v-if="menuShow" class="head_menu" style="display: block;">
					<li><a href="#" @click="onClickHelp">도움말</a></li>
					<li v-if="loginUse">
						<a href="#" @click="onClickMemEdit">개인정보수정</a>
					</li>
					<li v-if="loginUse">
						<a href="#" @click.prevent.stop="logout">로그아웃</a>
					</li>
				</ul>

			</transition>-->
			<!--// 메뉴 end -->
		</div>
	</div>
	<!--// 헤더 ens -->
</template>

<script>
// eslint-disable-next-line no-undef
require('es6-promise').polyfill();
import storage from '../api/storage';
import config from '../config/config.json';
import Help from './Help';
import MemberEdit from './member/MemberEdit';

export default {
	name: 'HeaderArea',
	props: {
		userInfo: {
			type: Object,
			default: null,
			required: false,
		},
		menuShow: {
			type: Boolean,
			default: false,
			required: false,
		},
		firstUser: {
			type: Boolean,
			default: false,
			required: false,
		},
    userLoginId: {
      type: String,
      default: "guest",
      required: true,
    },
	},
		data() {      
		return {
			user: {
				userNm: '',
        userId: this.userLoginId,
			},
			health: '',
			loginUse: false,			
		};
	},
	created() {
		if (this.firstUser) {
			this.onClickHelp();
		}
	},
	mounted() {
		this.user.userNm = this.userInfo.userNm;
		this.loginUse = config.LOGIN_USE;
		},

   watch: {
      userLoginId: function (val) {       
        this.user.userId = val;
      },
		},   //end watch

		methods: {
			onClickHome() {		

      },
		onClickHelp() {
			this.$modal.show(
				Help,
				{
					// id: this.userInfo.userId
				},
				{
					clickToClose: true,
					width: '100%',
					height: '100%',
				},
			);
		},
		onClickMemEdit() {
			this.$modal.show(
				MemberEdit,
				{
					id: this.userInfo.userId,
					type: 'user',
				},
				{
					clickToClose: true,
					height: 'auto',
				},
			);
		},
		logout() {
			// 로그아웃
			storage.removeUserData();
			window.location.href = config.PATH;
		},
	},
};
</script>
<style scoped>
/* transition fade */
.fade-enter-active {
	transition: 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderArea.vue